<template>
  <div>
    <div class="row">
      <div v-if="loaded && other_events.length > 0" class="px-0">
        <span>
          {{ $t('when-you-join-a-network-other-members-can-directly-message-you-on-the-platform-please-select-how-youd-like-to-receive-these-messages-or-opt-out-of-direct-messages-from-colleagues') }}
        </span>
        <div class="form pb-3">
          <div v-for="event in other_events" :key="event.id" class="row col-md-12 mt-3">
            <div v-for="(notification_option, index) in notification_options" :key="index" :class="['col-md-3', 'px-3', index === 2 ? 'text-center' : '']">
              <div class="form-check">
                <label class="form-check-label fs-7" :for="index">
                  <input
                    :id="index"
                    v-model="notificationMediumMsg"
                    :data-test="index"
                    type="radio"
                    :value="notification_option.value"
                    class="form-check-input check-input"
                    @change="updatePreference(event.id, notificationMediumMsg, $event, null)"
                  />
                  <span class="check-span">{{ notification_option.text }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="loaded && all_network_events.length > 0 && my_networks.length > 0" class="px-0">
        <hr class="mt-2" style="opacity: 0.5; height: 1px;" />
        <span>{{ $t('customize-notifications-for-each-of-your-networks') }}</span>
        <div class="col-md-12">
          <v-select
            id="selected_networks"
            v-model="selectedNetwork"
            data-test="selected_networks"
            :options="my_networks"
            label="name"
            :placeholder="this.$t('network.networkForm.selectNetwork')"
            class="my-2"
            style="float: left;"
            :style="{'width': my_networks.length > 1 ? '73%' : '100%'}"
          ></v-select>
          <h6 v-if="selectedNetwork && my_networks.length > 1" style="color:#005f9a; cursor: pointer; float: right; width: 22%; padding-top: 9px;" @click="showConfirmModal = true">
            {{ $t('apply-to-all-networks') }}
          </h6>
          <ConfirmModalWithInput
            placeholder="Type 'CONFIRM' to proceed"
            :showModal="showConfirmModal"
            confirmationText="CONFIRM"
            :okTitle="this.$t('Create.proceed')"
            @input-modal-confirmed="updateAllNetworks(selectedNetwork.id)"
            @input-modal-cancel="showConfirmModal = false"
          >
            {{ $t('you-are-about-to-apply-these-settings-to-all-of-your-networks') }}
          </ConfirmModalWithInput>
        </div>
        <div v-if="selectedNetwork" style="margin-top: 80px;">
          <hr style="background: repeating-linear-gradient(239deg, transparent, transparent 10px, black 10px, black 20px); margin: 10px 0px 20px 0px;">
          <span class="px-2" v-html="$t('select-notifications-you-receive-as-a-member-of-this-network')"></span>
          <div class="row col-md-12 mt-3">
            <div v-for="event in all_network_events" :key="event.id" class="col-md-4 pb-3">
              <div class="form-check">
                <input
                  id="notification_medium"
                  v-model="getPreferenceFromList(event.id, selectedNetwork.id)[notificationMedium]"
                  data-test="notification_medium"
                  type="checkbox"
                  class="form-check-input check-input"
                  @input="$event => updatePreference(event.id, notificationMedium, $event, selectedNetwork.id)"
                />
                <span class="check-span">{{ event.event_text }}</span>
              </div>
            </div>
          </div>
          <!--for managed networks-->
          <div v-if="selectedNetwork.my_role == 'admin'">
            <hr style="background: repeating-linear-gradient(239deg, transparent, transparent 10px, black 10px, black 20px); margin: 10px 0px 20px 0px;">
            <span class="px-2" v-html="$t('select-notifications-you-receive-as-an-administrator-of-this-network')"></span>
            <div class="row col-md-12 mt-3">
              <div v-for="event in managed_network_events" :key="event.id" class="col-md-4 pb-3">
                <div class="form-check">
                  <input
                    id="notification_medium"
                    v-model="getPreferenceFromList(event.id, selectedNetwork.id)[notificationMedium]"
                    data-test="notification_medium"
                    type="checkbox"
                    class="form-check-input check-input"
                    @input="$event => updatePreference(event.id, notificationMedium, $event, selectedNetwork.id)"
                  />
                  <span class="check-span">{{ event.event_text }}</span>
                </div>
              </div>
            </div>
          </div>
          <hr style="background: repeating-linear-gradient(239deg, transparent, transparent 10px, black 10px, black 20px); margin: 10px 0px 20px 0px;">
          <span class="px-2">
            {{ $t('please-select-how-youd-like-to-receive-these-notifications') }}
          </span>
          <div class="row col-md-12 mt-3">
            <div v-for="(notification_option, index) in notification_options.slice(0,3)" :key="index" class="col-md-4 px-3">
              <div class="form-check">
                <label class="form-check-label fs-6" :for="index">
                  <input
                    :id="index"
                    v-model="notificationMedium"
                    :data-test="index"
                    name="notificationMedium"
                    type="radio"
                    :value="notification_option.value"
                    class="form-check-input check-input"
                    @change="updateNotificationMedium(notification_option.value), updatePreferenceForNetwork(notificationMedium, selectedNetwork.id)"
                  />
                  <span class="check-span">{{ notification_option.text }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="loaded && noNetworks" class="px-0">
        <hr class="mt-2" style="opacity: 0.5; height: 1px;" />
        {{ $t('youre-not-a-member-of-any-network-join-one-or-more-to-receive-updates-from') }} <a href="/">{{ $t('network.heading') }}.</a>
      </div>
    </div>
    <div v-if="saved">
      <div class="alert alert-success alert-dismissible mt-4 mb-0" role="alert">
        <i class="fas fa-check"></i>
        {{ $t('ResearchCreds.your-information-was-saved') }}
        <button id="close" data-test="close" type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
    </div>
    <div v-if="!loaded" class="text-center mt-4">
      <lottie-player
        autoplay
        loop
	      speed="2.5"
        src="/img/animations/custom_loader.json"
        style="height: 130px;"
        >
      </lottie-player>
    </div>
  </div>
</template>
<script>
import ConfirmModalWithInput from '@/components/commons/Modals/ConfirmModalWithInput.vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  components: {
    ConfirmModalWithInput,
    vSelect,
  },
  data() {
    return {
      toggleIcon: false,
      my_networks: [],
      my_managed_networks: [],
      managed_network_events: [],
      all_network_events: [],
      other_events: [],
      selectedManagedNetwork: null,
      selectedNetwork: null,
      notificationPreferences: [],
      loaded: false,
      saved: false,
      notificationMediumMsg: 'receive_both',
      notificationMedium: 'receive_both',
      notification_options: [
        { text: 'Email', value: 'receive_email' },
        { text: 'Homepage Broadcast ', value: 'receive_notification' },
        { text: 'Both', value: 'receive_both' },
        { text: 'Opt out', value: 'opt_out' },
      ],
      showConfirmModal: false,
    };
  },
  computed: {
    noNetworks() {
      return this.my_managed_networks.length === 0 && this.my_networks.length === 0;
    },
  },
  watch: {
    notificationMedium(newNotificationMedium) {
      this.updateNotificationMedium(newNotificationMedium);
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      // try checking if this was updated by updating user
      this.$http.get('notification-events').then(resp => {
        this.my_networks = resp.data.my_networks;
        this.all_network_events = resp.data.all_network_events;
        this.managed_network_events = resp.data.managed_network_events;
        this.my_managed_networks = resp.data.my_managed_networks;
        this.my_networks = resp.data.my_networks;
        this.other_events = resp.data.other_events;

        this.$http.get('/auth/notification-preferences').then(resp => {
          this.my_networks.forEach(network => {
            this.all_network_events.forEach(e => this.loadPreferenceFromEvent(resp.data, e, network.id));
          });
          // removes New Message in Network event (default true for email and broadcast)
          this.all_network_events.pop();

          this.my_managed_networks.forEach(network => {
            this.managed_network_events.forEach(e => this.loadPreferenceFromEvent(resp.data, e, network.id));
          });

          this.other_events.forEach(e => this.loadPreferenceFromEvent(resp.data, e));

          this.loaded = true;
        });
      });
    },
    loadPreferenceFromEvent(preferences, event, network_id = null) {
      let existingPreference = preferences.find(p => p.notification_event_id === event.id && p.network_id == network_id);
      let preference = null;
      if (existingPreference) {
        preference = {
          notification_event_id: event.id,
          receive_email: existingPreference.receive_email,
          receive_notification: existingPreference.receive_notification,
          receive_both: existingPreference.receive_email == true && existingPreference.receive_notification == true,
          network_id: network_id,
        };
      } else {
        preference = {
          notification_event_id: event.id,
          receive_email: event.receive_email_fallback,
          receive_notification: event.receive_notification_fallback,
          receive_both: event.receive_email_fallback == true && event.receive_notification_fallback == true,
          network_id: network_id,
        };
      }
      this.notificationPreferences.push(preference);
    },
    getPreferenceFromList(event_id, network_id = null) {
      let val = this.notificationPreferences.find(p => p.notification_event_id == event_id && p.network_id == network_id);
      return val;
    },
    updatePreference(event_id, preference, $event, network_id) {
      let pref = this.getPreferenceFromList(event_id, network_id);
      switch (preference) {
        case 'receive_email':
          pref['receive_email'] = $event.target.checked;
          pref['receive_notification'] = !$event.target.checked;
          break;
        case 'receive_notification':
          pref['receive_email'] = !$event.target.checked;
          pref['receive_notification'] = $event.target.checked;
          break;
        case 'receive_both':
          pref['receive_email'] = $event.target.checked;
          pref['receive_notification'] = $event.target.checked;
          break;
        case 'opt_out':
          pref['receive_email'] = !$event.target.checked;
          pref['receive_notification'] = !$event.target.checked;
          pref['receive_both'] = !$event.target.checked;
          break;
        default:
          break;
      }
      this.$http.post('/auth/notification-preferences/update-or-create', pref);
    },
    updatePreferenceForNetwork(preference, network_id) {
      let pref = {
        network_id: network_id,
      };
      if (preference == 'receive_both') {
        pref['receive_email'] = true;
        pref['receive_notification'] = true;
      } else {
        pref['receive_email'] = preference == 'receive_email';
        pref['receive_notification'] = preference == 'receive_notification';
      }
      this.$http.post('/auth/notification-preferences/update-or-create-for-network', pref);
    },
    updateNotificationMedium(medium) {
      this.notificationMedium = medium;
    },
    updateAllNetworks(networkID) {
      this.showConfirmModal = false;
      let chosenNotifs = [];
      this.notificationPreferences.forEach(element => {
        if (element.network_id == networkID) {
          chosenNotifs.push(element);
        }
      });
      this.$http.post('/auth/notification-preferences/update-or-create-for-all', chosenNotifs).then(() => {
        this.saved = true;
      });
    },
  },
};
</script>
<style scoped>
.check-span {
  vertical-align: sub !important;
  margin-left: 10px !important;
}
.check-input {
  width: 1.5em !important;
  height: 1.5em !important;
}
</style>